import { parseStringPromise } from 'xml2js';


export const XMLToJSON = async (xml: any) => {
    
    let xmlConverted = null;
    try {
        xmlConverted = await parseStringPromise(xml);
    } catch (err) {
        //console.error('Error converting XML to JSON', err);
    }

    return  xmlConverted;
}